{
    "participant_info": {
        "sectionId": "participant_info",
        "header": "Registration Information",
        "available_actions": null,
        "attributes": [
            {
                "attribute_ID": "lang",
                "fieldName": "lang",
                "label": "Preferred Language",
                "type": "select",
                "mandatory": "Y",
                "validator": null,
                "tooltip": "Please select a preferred language.",
                "isAvailable": "Y",
                "placeholder": "Preferred Language"
            },
            {
                "attribute_ID": "focusArea",
                "fieldName": "focusArea",
                "label": "Focus Area",
                "type": "select",
                "mandatory": "N",
                "validator": null,
                "tooltip": "Please select a focus area.",
                "isAvailable": "Y",
                "placeholder": "Focus Area"
            },
            {
                "attribute_ID": "specialAccommodations",
                "fieldName": "specialAccommodations",
                "label": "Special Accommodations",
                "type": "select",
                "mandatory": "N",
                "validator": null,
                "tooltip": "Please select Special Accommodations.",
                "isAvailable": "Y",
                "placeholder": "Special Accommodations"
            },
            {
                "attribute_ID": "address",
                "fieldName": "address",
                "label": "Consumer Address",
                "type": "select",
                "mandatory": "N",
                "validator": null,
                "tooltip": "Please type an address.",
                "isAvailable": "Y",
                "placeholder": "Address"
            },
            {
                "attribute_ID": "distance",
                "fieldName": "distance",
                "label": "Search Radius (Approximate distance)",
                "type": "select",
                "mandatory": "N",
                "validator": null,
                "tooltip": "Please select distance.",
                "isAvailable": "Y",
                "placeholder": "Distance"
            },
            {
                "attribute_ID": "distanceFilter",
                "fieldName": "distanceFilter",
                "label": "Visit Type",
                "type": "select",
                "mandatory": "N",
                "validator": null,
                "tooltip": "Please select distance.",
                "isAvailable": "Y",
                "placeholder": "Distance filter"
            },
            {
                "attribute_ID": "officeDistance",
                "fieldName": "officeDistance",
                "label": "Office Distance",
                "type": "select",
                "mandatory": "N",
                "validator": null,
                "tooltip": "Please select a office distance.",
                "isAvailable": "Y",
                "placeholder": "Office Distance"
            },
            {
                "attribute_ID": "fiOrgName",
                "fieldName": "fiOrgName",
                "label": "CDPAP Facilitator",
                "type": "input",
                "mandatory": "N",
                "validator": null,
                "tooltip": "Please select CDPAP Facilitator",
                "isAvailable": "Y",
                "placeholder": "CDPAP Facilitator"
            }
        ],
        "validations": [
            {
                "whatToCheck": "atLeastXEntered",
                "clientOrServer": "C",
                "attributes": [
                      {
                        "validatorid": 1,
                        "attribute_ID": ["lang"],
                        "functionParams": {
                          "ErrMsg": "Please select a preferred language."
                        }
                      }
                ]
            }
        ],
        "actions": [
            {
                "Name": "Previous",
                "Validate": null
            },
            {
                "Name": "Next",
                "Validate": [
                    {
                        "checkType": "atLeastXEntered",
                        "validatorid": [
                            1
                        ]
                    }
                ]
            }
        ]
    }
}